var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71848 1.15229C7.7128 1.28288 7.64467 1.42483 7.52543 1.54406C6.28766 2.78184 5.04421 4.02529 3.80644 5.26306C3.51119 5.55831 3.18755 5.56398 2.89798 5.28009C2.28477 4.67256 1.67724 4.05935 1.06403 3.44615C0.888021 3.27013 0.808531 3.06005 0.893699 2.82158C0.967511 2.59447 1.13217 2.4582 1.37064 2.42413C1.57504 2.39574 1.74538 2.46955 1.893 2.61718C2.34155 3.06573 2.7901 3.51428 3.23865 3.96851C3.32382 4.05368 3.36924 4.05935 3.45441 3.97419C4.50481 2.91811 5.55522 1.8677 6.60562 0.811622C6.78163 0.635609 6.95765 0.482306 7.23018 0.533407C7.5084 0.57883 7.71848 0.822977 7.71848 1.15229Z",
    fill: "#F6F8F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTick);
export default __webpack_public_path__ + "static/media/activeTick.f1a0670cc21d4819ca92f389b134df3b.svg";
export { ForwardRef as ReactComponent };